import ConfigurationPage from "templates/ConfigurationPage";
import ViewLocation from "./ViewLocation";
import BedsList from "./BedsList";

const ViewLocationInfo = (props) => {
        const commonProps = {
            locationId: props.match.params.location,
            org: props.auth.currentUser.defaultOrg,
            history: props.history,
            auth: props.auth
        }

        return (
            <ConfigurationPage
                pageTitle="Locations"
                pageSubTitle={commonProps.locationId}
                className="locations"
                history={props.history}
            >

                <ViewLocation {...commonProps} />
                <BedsList {...commonProps}/>
            </ConfigurationPage>
        );
    };

export default ViewLocationInfo;